import React, { useLayoutEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { useIsSmallScreen } from "../../App";
import { RUBRIC_COLOR } from "../../tokens";
import { capitalizeFirstWord } from "./ordinariate-liturgy";

const NULL: any = null;

function replaceCaretsWithAsteriskSpan(element) {
    // Create a TreeWalker to visit all text nodes
    const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null
    );

    // Array to store nodes that need replacement
    // (We can't modify the DOM while walking the tree)
    const nodesToProcess = [];

    // Collect all text nodes containing "^^^"
    let currentNode;
    while ((currentNode = walker.nextNode())) {
        if (currentNode.nodeValue.includes("^^^")) {
            nodesToProcess.push(currentNode);
        }
    }

    // Process each node that needs replacement
    nodesToProcess.forEach((textNode) => {
        const parent = textNode.parentNode;
        const text = textNode.nodeValue;

        // Split the text by "^^^"
        const parts = text.split("^^^");

        // If there's only one part, then "^^^" wasn't found (shouldn't happen due to our check above)
        if (parts.length === 1) return;

        console.log(parts);

        // Create a document fragment to hold the new nodes
        const fragment = document.createDocumentFragment();

        // Add each part with an asterisk span in between
        for (let i = 0; i < parts.length; i++) {
            // Add the text part
            if (parts[i]) {
                fragment.appendChild(document.createTextNode(parts[i]));
            }

            // Add the asterisk span after all but the last part
            if (i < parts.length - 1) {
                const span = document.createElement("span");
                span.style.color = RUBRIC_COLOR;
                span.textContent = "*";
                fragment.appendChild(span);
            }
        }

        // Replace the original text node with our fragment
        parent.replaceChild(fragment, textNode);
    });
}

export const MarkdownTextLine: React.FC<{
    content: string;
    indent?: number;
    dropCap?: boolean;
}> = (props) => {
    const { content, indent, dropCap } = props;

    const isSmallScreen = useIsSmallScreen();

    let initialLength = dropCap ? 1 : 0;
    while (
        !"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".includes(
            content[initialLength - 1]
        ) &&
        dropCap
    ) {
        initialLength++;
    }

    const capitalized = dropCap ? capitalizeFirstWord(content) : content;

    const initial = capitalized.slice(0, initialLength);
    const main = capitalized.slice(initialLength);

    const containerRef = useRef<HTMLDivElement>(NULL);

    useLayoutEffect(() => {
        const el = containerRef.current.querySelector("p");

        const existingInitialSmall = containerRef.current.querySelector(
            "p span.initial-small"
        );
        const existingInitialLarge =
            containerRef.current.querySelector("p span.initial");

        const existingInitial = existingInitialSmall || existingInitialLarge;

        const initialEl = document.createElement("span");
        initialEl.className = isSmallScreen ? "initial-small" : "initial";
        initialEl.appendChild(document.createTextNode(initial));

        if (el && !existingInitial && dropCap) {
            el.insertBefore(initialEl, el.childNodes[0] || null);
        }

        replaceCaretsWithAsteriskSpan(containerRef.current);
    });

    return (
        <div
            style={{
                paddingLeft:
                    indent === 10
                        ? 0
                        : (indent ?? 0) * (isSmallScreen ? 16 : 24),
                paddingTop: (indent ?? 0) === 0 ? 6 : 0,
                paddingBottom: (indent ?? 0) === 0 ? 6 : 0,
                textAlign:
                    indent === 10
                        ? "right"
                        : (indent ?? 0) === 0
                        ? "justify"
                        : "left",
            }}
            ref={containerRef}
            className="markdown-text-line"
            data-content={content}
            data-indent={indent}
        >
            <ReactMarkdown>{main.replace(/\\n/g, "  \n")}</ReactMarkdown>
        </div>
    );
};
